import { INPUT_VALIDATION } from '@js/common/constants'
import { VALIDATION_FUNCTIONS, validationTypes } from '@js/common/validation'

import { FormElement } from '@f/elements/FormWrapper/Context'

interface SingleInputValidation {
  rule: validationTypes
  message: string
}

interface CrossFieldInputValidation {
  rule: validationTypes
  message: string
  linkedFieldName: keyof typeof INPUT_VALIDATION
  invalidIf: (currentValue: string, linkedFieldValue: string) => boolean
}

export type InputValidation = SingleInputValidation | CrossFieldInputValidation

export function isFailedSingleFieldValidation(
  valueToCheck: string,
  validation: SingleInputValidation
): boolean {
  const { rule } = validation

  return !VALIDATION_FUNCTIONS[rule]?.(valueToCheck)
}

export function isFailedCrossFieldValidation(
  valueToCheck: string,
  formElements: FormElement[],
  validation: CrossFieldInputValidation
): boolean {
  const { invalidIf, linkedFieldName } = validation
  const linkedField = formElements.find(el => el.name === linkedFieldName)

  if (!linkedField) {
    return false
  }

  return invalidIf(valueToCheck, linkedField.value)
}

export const isCrossFieldValidation = (
  validation: InputValidation
): validation is CrossFieldInputValidation =>
  Object.prototype.hasOwnProperty.call(validation, 'linkedFieldName')
